import { apiClient } from "../config";
import { env } from "../../config/env";
import {
  RegisterPayload,
  LoginPayload,
  ForgotPasswordPayload,
  VerifyCodePayload,
  ResetPasswordPayload,
  AuthResponse,
} from "../interface/auth.interface";
import { User } from "../interface/user.interface";

/**
 * 🔐 AUTH SERVICE
 */

class AuthService {
  /**
   * 📝 REGISTER
   */
  async register(data: RegisterPayload): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.REGISTER_URL,
      data
    );

    return response.data;
  }

  /**
   * 🔑 LOGIN
   */
  async login(data: LoginPayload): Promise<AuthResponse> {
    try {
      const response = await apiClient.post<AuthResponse>(
        env.LOGIN_URL,
        data,
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch (error: any) {
      // Lancer l'erreur Axios complète, pas seulement response.data
      throw error;
    }
  }

  /**
   * 🚪 LOGOUT
   * Le backend supprimera le cookie httpOnly
   */
  async logout(): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.LOGOUT_URL
    );

    return response.data;
  }

  /**
   * 🔁 FORGOT PASSWORD
   */
  async forgotPassword(
    data: ForgotPasswordPayload
  ): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.FORGOT_PASSWORD_URL,
      data
    );

    return response.data;
  }

  /**
   * 🔢 VERIFY CODE
   */
  async verifyCode(
    data: VerifyCodePayload
  ): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.VERIFY_CODE_URL,
      data
    );

    return response.data;
  }

  /**
   * 🔄 RESET PASSWORD
   */
  async resetPassword(
    data: ResetPasswordPayload
  ): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.RESET_PASSWORD_URL,
      data
    );

    return response.data;
  }

  /**
   * 👤 GET CURRENT USER
   * Permet de vérifier si l’utilisateur est connecté
   */
  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<any>(
      env.USER_INFOS_URL
    );

    return response.data.data.user;
  }
}

/**
 * Export instance unique
 */
export const authService = new AuthService();